import React, { useEffect, useState, useCallback, memo } from 'react';
import { throttle } from 'lodash';
import { useBreakpoints, Directions, Breakpoints } from 'src/utils/breakpoint-utils';
import DesktopHeader from './desktop';
import MobileHeader from './mobile';

interface HeaderProps {
    color: string;
    path: string;
}

const Header = ({ color, ...rest }: HeaderProps) => {
    const [scrollPos, setScrollPos] = useState(0);
    const isMobile = useBreakpoints(Breakpoints.lg, Directions.down);

    const detailsPathPattern = /^\/(series|workouts)\/[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+\/?$/;
    const hasPreview = !!rest.path.match(detailsPathPattern);

    const handleScroll = useCallback(() => {
        const scrollY = window?.scrollY || 0;

        throttle(() => {
            setScrollPos(scrollY);
        }, 100)();
    }, []);

    useEffect(() => {
        document.addEventListener('scroll', handleScroll);

        return () => {
            document.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    return isMobile ? (
        <MobileHeader color={color} hasPreview={hasPreview} scrollPos={scrollPos} {...rest} />
    ) : (
        <DesktopHeader color={color} hasPreview={hasPreview} scrollPos={scrollPos} {...rest} />
    );
};

export default memo(Header);
